import { Component, effect, inject, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../core/service/auth/authentication.service';
import { SharedModule } from '../shared.module';
import { HeaderService } from '../../services/header.service';
import { ResetPasswordComponent } from '../../pages/auth/reset-password/reset-password.component';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from '../../core/service/localStorage/local-storage.service';
import { DelegateUserAccessComponent } from '../delegate-user-access/delegate-user-access.component';
import { PopupServiceService } from '../../core/service/popup/popup-service.service';
import { LoaderService } from '../../core/service/loader.service';
import { Subject, takeUntil } from 'rxjs';
import { urlRoutes } from '../../core/constants/url-route.constant';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { SearchResultDialogComponent } from '../search-result-dialog/search-result-dialog.component';
import { environment } from '../../../environments/environment';
import { EmployeeDirectoryComponent } from '../../features/headers/employee-directory/employee-directory.component';
import { MatBadgeModule } from '@angular/material/badge';
import { NotificationsComponent } from '../../features/headers/notifications/notifications.component';
import { CoreSocketService } from '../../core/service/core-socket/core-socket.service';
import { MailCacheService } from '../../core/service/mailCache/mail-cache.service';
import { PermissionsPipe } from '../../core/pipe/permissions.pipe';
import { permissionEntity } from '../../core/constants/permission';
import { OverlayModule } from '@angular/cdk/overlay';
import { CustomComponentComponent } from '../../features/headers/custom-component/custom-component.component';
import { FileMangerService } from '../../core/service/file-manger/file-manger.service';
import { SwitchUserComponent } from '../../features/file-manager-v3/switch-user/switch-user.component';
import { SignOffChoiceComponent } from '../sign-off-choice/sign-off-choice.component';
import { TmsSocketService } from '../../core/service/tms-socket/tms-socket.service';
import { TMSService } from '../../core/service/tms/tms.service';
import { TMS_MANUAL_AWAY_OPTION } from '../../core/constants/tms.const';
import { IdleActivityService } from '../../core/service/idle-activity/idle-activity.service';
import { AllApplicationService } from '../../core/service/all-application/all-application.service';
import { ThemeService } from '../../core/service/theme/theme.service';

interface PaginationType {
  size?: number,
  total?: number,
  skip: number,
  limit: number
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, SharedModule, MatBadgeModule, NotificationsComponent, PermissionsPipe, OverlayModule, CustomComponentComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnDestroy {
  brandLogo = './assets/images/logo.svg';
  // brandLogo = './assets/images/studies-planet_crizac.png';
  auth = inject(AuthenticationService);
  notificationService = inject(HeaderService);
  router = inject(Router);
  localStorageService = inject(LocalStorageService);
  readonly dialog = inject(MatDialog);
  readonly popup = inject(PopupServiceService);
  public loader = inject(LoaderService);
  private mailCacheService = inject(MailCacheService);
  private allApplicationService = inject(AllApplicationService);
  private themeService = inject(ThemeService);

  isSwitchUser: boolean = false;
  DelisSwitchUser: boolean = false;
  switchUserData: any;
  search: any;
  search_applicant_list: any;
  pagination_config: PaginationType = {
    size: 10,
    total: 0,
    skip: 0,
    limit: 10,
  };
  employee_mobile_extension: string = '';
  private _unsubscribeAll: Subject<any> = new Subject();
  @ViewChild('applicant_menu_trigger') applicant_menu_trigger!: MatMenuTrigger;
  @ViewChild('travelEvent') travelEvent!: MatMenu;
  @ViewChild(CustomComponentComponent) qrRef!: CustomComponentComponent;
  environment = environment;
  selectedImageSrc: string = './assets/images/favicon_crizac.png';
  extNo: any;
  userName: any;
  jobRole: any
  permissions_entity = permissionEntity;
  currentUsers: any;

  private static readonly _LOGOUT_KEY = 'tms_logout_signal';
  private _logoutStorageListener: ((e: StorageEvent) => void) | null = null;
  isOpen = false
  idPemission: boolean = false;
  userPermissions = ["117", "152", "169", "1329", "1372", "1179", "751", "132", '750'];
  enrolyPermissionUserIds = new Set(['1089', '132', '115', '169', '161']);

  isMoMoPermission: boolean = false;
  isEnrolyPermission: boolean = false;
  notificationEnabled: boolean = true;
  momoPermissionUserIds = [
    { id: '117', name: 'Manish Agarwal' },
    { id: '152', name: 'Vikash Agarwal' },
    { id: '169', name: 'Priya Fulfagar' },
    { id: '1329', name: 'Dishant Kharbanda' },
    { id: '1372', name: 'Nikhil Jain' },
    { id: '1179', name: 'Sourav Kumar Bhaduri' },
    { id: '751', name: 'Aditya Jain' },
    { id: '132', name: 'Sibendu Roy' },
    { id: '750', name: 'Rituparno Sarkar' },
    { id: '128', name: 'Salaria Zaheer' },
  ];

  // Check if currently on mail page
  get isOnMailPage(): boolean {
    return this.router.url === '/mail';
  }

   private readonly LoaderService = inject(LoaderService);
   private readonly fileMangerService = inject(FileMangerService);
   private readonly tmsSocketService = inject(TmsSocketService);
   private readonly tmsService = inject(TMSService);
   private readonly idleActivityService = inject(IdleActivityService);
  constructor(
    private headerService: HeaderService,
    private _authenticationService: AuthenticationService,
    private socketService: CoreSocketService,
  ) { }

  async ngOnInit() {
    // Reconnect TMS socket on page refresh (connect() is a no-op if already connected)
    this.tmsSocketService.connect();

    // Register cross-tab logout listener first — before any early returns
    this._logoutStorageListener = (e: StorageEvent) => {
      if (e.key === HeaderComponent._LOGOUT_KEY && e.newValue === 'true') {
        localStorage.removeItem(HeaderComponent._LOGOUT_KEY);
        // Clear local state so guards don't interfere on next login
        localStorage.removeItem('tms_day_started');
        this.router.navigate(['/login']);
      }
    };
    window.addEventListener('storage', this._logoutStorageListener);

    const switchUserValue =
      await this.localStorageService.getKeyIndexedDbKey('switchUser');

    this.isSwitchUser = !!switchUserValue;

    this.isSwitchUser = JSON.parse(
      this.localStorageService.getKey('isSwitchUser') || 'false'
    );

    const currentUser =
      await this.localStorageService.getKeyIndexedDbKey('currentUser');
    this.currentUsers = currentUser;

    if (this.isSwitchUser) {
      setTimeout(() => this.loadSwitchUser(), 400);
    } else if (currentUser?.trackInactivity !== false && currentUser?.trackInactivity !== 'false') {
      // Auto-lock onto the away screen after a minute of inactivity across all tabs
      // (skipped when the login API explicitly reports trackInactivity: false)
      this.idleActivityService.start();
    }
    const notice = this.currentUsers?.noticeHideShow
    this.notificationEnabled = notice === 'true' ? true : false
    this.idPemission = this.userPermissions.includes(this.currentUsers?.id);
    this.isMoMoPermission = this.momoPermissionUserIds.some(user => user.id === this.currentUsers?.id);

    const displayUser = this.isSwitchUser ? switchUserValue : currentUser;

    this.userName = displayUser?.name;
    this.jobRole = displayUser?.roles?.[0]?.name;
    this.extNo = displayUser?.extension;
    this.selectedImageSrc = displayUser?.profilepic
      ? `${environment.fileBaseUrl}${displayUser.profilepic}`
      : './assets/images/favicon_crizac.png';

    if (displayUser?.profilepic) {
      this.selectedImageSrc = `${environment.fileBaseUrl}${displayUser.profilepic}`;
    } else if (displayUser?.roles?.[0]?.id === '160') {
      this.selectedImageSrc = './assets/images/studies-planet.png';
    } else if (displayUser?.roles?.[0]?.id === '156') {
      this.selectedImageSrc = './assets/images/global-tree_favicon.png';
    } else {
      this.selectedImageSrc = './assets/images/favicon_crizac.png';
    }

    // Logo logic remains same
    if (displayUser?.roles?.[0]?.id === '160') {
      this.brandLogo = './assets/images/studies-planet_crizac.png';
    } else {
      this.brandLogo = './assets/images/logo.svg';
    }

    // Account access (delegate)
    if (currentUser?.accountAccess && currentUser.accountAccess.length > 0) {
      this.DelisSwitchUser = true;
    }

    this.hasEnrolyPermission().then(res => this.isEnrolyPermission = res);
  }

  ngOnDestroy(): void {
    if (this._logoutStorageListener) {
      window.removeEventListener('storage', this._logoutStorageListener);
      this._logoutStorageListener = null;
    }
    this.idleActivityService.stop();
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  get tooltipText(): string {
    return `${this.userName} (${this.jobRole})`;
  }

  async loadSwitchUser() {
    try {
      const res = await this.localStorageService.getKeyIndexedDbKey(
        'switchUser'
      );
      this.switchUserData = res;
    } catch (err) {
      console.error('Error:', err);
    }
  }

  logout(): void {
    if (this.currentUsers?.email === 'automation@crizac.com') {
      this._doLogout();
      return;
    }

    const dialogRef = this.dialog.open(SignOffChoiceComponent, {
      panelClass: 'custom-dialog-container',
      width: '480px',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((choice: 'end_day' | 'temporary' | undefined) => {
      if (choice === 'end_day') {
        this.router.navigate(['/sign-off-wrapup']);
      } else if (choice === 'temporary') {
        this._doLogout();
      }
    });
    // this._doLogout();
  }

  private _doLogout(): void {
    this.auth.logout().subscribe({
      next: async (res: any) => {
        if (res?.data?.status) {
          // Signal other tabs to logout — must be before disconnect clears localStorage
          localStorage.setItem(HeaderComponent._LOGOUT_KEY, 'true');
          this.socketService.disconnect();
          this.tmsSocketService.disconnect();
          this.tmsService.reset();
          this.localStorageService.removeIndexedDbKey('currentUser');
          this.localStorageService.clearIndexedDb();
          this.localStorageService.removeIndexedDbKey('switchUser');
          this.localStorageService.removeKey('access_token');
          this.localStorageService.removeKey('refreshToken');
          this.localStorageService.removeKey('switchUserToken');
          this.localStorageService.removeKey('isSwitchUser');
          this.localStorageService.removeKey('twoFactorVerified');
          this.localStorageService.removeKey('roles_permissions');
          this.localStorageService.removeKey('notification_banner_shown');
          this.localStorageService.removeKey('currentUserMailDetails');
          await this.mailCacheService.clearAllCache();
          this.router.navigate(['/login']);
        } else {
          alert('Invalid credentials');
        }
      },
      error: () => {
        alert('Login failed. Please try again.');
      },
    });
  }

  openDialog(): void {
    this.dialog.open(ResetPasswordComponent, {
      panelClass: 'custom-dialog-container',
      width: '440px',
      disableClose: true,
    });
  }

  get isDarkMode(): boolean {
    return this.themeService.isDarkMode;
  }

  toggleTheme(): void {
    this.themeService.toggle();
  }
  /*
  getDarkModeExtension(): void {
    window.open('https://chromewebstore.google.com/detail/dark-theme-dark-mode-for/gjjbmfigjpgnehjioicaalopaikcnheo', '_blank');
  }
  */
  async delegateUserAccessDialog() {
    this.loader.show();
    const userData = await this.localStorageService.getKeyIndexedDbKey(
      'currentUser'
    );
    const Ids = userData?.accountAccess
      .map((item: any) => item?.userId)
      .join(',');
    this.auth
      .getUserDetails(userData?.accountAccess.length > 0 ? Ids : userData?.id)
      .subscribe({
        next: (res: any) => {
          if (res?.success) {
            this.loader.hide();
            this.dialog.open(DelegateUserAccessComponent, {
              panelClass: 'custom-dialog-container',
              disableClose: true,
              width: '1000px',
              data: res?.data,
            });
          } else {
            alert('Invalid credentials');
          }
        },
        error: () => {
          alert('Login failed. Please try again.');
        },
      });
  }

  // Profile
  openProfileDialog() {
    this.router.navigate(['/dashboard/profile']);
  }
  //commission
  gotoCrizac() {
    this.router.navigate(['/dashboard/crizac']);
  }
  gotoUcol() {
    this.router.navigate(['/dashboard/ucol']);
  }
  gotoGaspl() {
    this.router.navigate(['/dashboard/gaspl']);
  }
  exitSwitchUser() {
    this.localStorageService.removeIndexedDbKey('switchUser');
    this.localStorageService.removeKey('switchUserToken');
    this.localStorageService.removeKey('isSwitchUser');
    window.location.href = '/dashboard/main-dashboard';
  }

  // ============================================================
  // 🔹 Redirect Servies
  // ============================================================

  redirectToFileManagerPage() {
    this.router.navigate(['/dashboard/file-manager-2/my-drive-2']);
  }

  async goToFileManager(payload: any) {
    this.LoaderService.show();

    this.fileMangerService.fileManagerV3(payload).subscribe({
      next: (res: any) => {
        const loginUrl = res.data.data.loginUrl;

        if (loginUrl) {
          const userDetails = res?.data?.userDetails;
          window.open(`${loginUrl}&userData=${encodeURIComponent(
            btoa(JSON.stringify(userDetails))
          )}`, '_blank');
          // console.log("loginUrl: ", `&userData=${encodeURIComponent(
          //   btoa(JSON.stringify(userDetails))
          // )}`);

          this.LoaderService.hide();
        } else {
          console.error('Login URL not found in response');
          this.LoaderService.hide();
        }

      }, error: (err: any) => {
        console.error("Something Went Wrong!!");
        this.LoaderService.hide();
      }
    })

  }

  async goToFileManagerV3() {

    const currentUser = await this.localStorageService.getKeyIndexedDbKey('switchUser') ? null :
      await this.localStorageService.getKeyIndexedDbKey('currentUser');

    // console.log("currentUser: ", currentUser);

    if (!currentUser) {
      const message = "You are a delegated user and do not have access to the Drive feature. Please contact the Admin for assistance if needed.";
      this.popup.successAndErrorDialog('info', message);
      return;
    } else if (currentUser.id === '132' || currentUser.id === '152' || currentUser.id === '1089') {

      const dialogRef = this.dialog.open(SwitchUserComponent, { width: '450px' });

      dialogRef.afterClosed().subscribe(result => {
        if (result.status) {
          this.goToFileManager(result.payload);
        } else if (!result.status) {
          const payload = {
            crizac_user_id: currentUser?.id,
            crizac_email: currentUser?.email,
            username: currentUser?.driveData?.userName,
          };
          this.goToFileManager(payload);
        }
      });
      return;

    } else if (currentUser?.driveData?.driveAccess === 'true'){
      const payload = {
        crizac_user_id: currentUser?.id,
        crizac_email: currentUser?.email,
        username: currentUser?.driveData?.userName,
      };
      this.goToFileManager(payload);
    }
    else{
      const message = "You do not have access to the Drive feature. Please contact the Admin for assistance if needed.";
      this.popup.successAndErrorDialog('info', message);
      return;
    }

  }

  redirectToLeavesPage() {
    this.router.navigate(['/dashboard/travel-events']);
  }

  redirectMeetingEvents() {
    this.router.navigate(['/dashboard/meeting-events']);
  }

  redirectRoomBooking() {
    this.router.navigate(['/dashboard/conference-room/book']);
  }

  redirectToMailPage() {
    window.open(`/mail`, '_blank');
    // this.router.navigate(['/mail']);
  }

  redirectToDashboard() {
    this.router.navigate(['/dashboard/all-application']);
  }

  gotoAdminNotice() {
    this.router.navigate(['/dashboard/notice']);
  }
  gotoFrontendNotice() {
    this.router.navigate(['/dashboard/notice/frontend-notice']);
  }
  gotoFrontendWebinar() {
    this.router.navigate(['/dashboard/notice/frontend-webinar']);
  }

  // Header Search
  searchApplicant(isArchived = false) {
    if (this.search) {
      this.loader.show();
      this.headerService
        .globalSearch(this.pagination_config, this.search.trim(), isArchived)
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(
          (result) => {
            this.loader.hide();
            if (result?.data?.data?.length) {
              this.search_applicant_list = this.getConvertedArray(
                result.data.data
              );
              this.pagination_config.total = result.data.total;
              this.dialog.open(SearchResultDialogComponent, {
                width: 1115 + 'px',
                maxWidth: 'auto',
                data: {
                  search: this.search,
                  results: this.search_applicant_list,
                },
                position: { top: '80px' },
              });
            } else if (!isArchived) {
              this.popup.confirmPopup('info', 'There no application in current Application List Do you want me to search in the Archived?', '').subscribe((res) => {
                if (res === 'yes') {
                  this.searchApplicant(true);
                } else {
                  // this.dialog.open(SearchResultDialogComponent, {
                  //   width: '700px',
                  //   data: { search: this.search, results: [] },
                  //   position: { top: '80px' },
                  // });
                  return;
                }
              });
            } else {
              this.dialog.open(SearchResultDialogComponent, {
                width: '700px',
                data: { search: this.search, results: [] },
                position: { top: '80px' },
              });
            }
          },
          (err) => {
            this.loader.hide();
            console.error('Search error:', err);
          }
        );
    }
  }

  async hasEnrolyPermission() {
    const currentUser = await this.localStorageService.getKeyIndexedDbKey('switchUser') ? null :
      await this.localStorageService.getKeyIndexedDbKey('currentUser');
    return !!currentUser?.id && this.enrolyPermissionUserIds.has(currentUser.id);
  }

  Enroly() {
    const token = localStorage.getItem('access_token');
    const url = `${environment.enrolyUrl}?token=${token}`;
    if (token) {
      window.open(url, '_blank');
    }
  }

  getConvertedArray(data: any[]): any[] {
    return data.map((item) => ({
      ...item,
      dynamicUrl: this.buildDynamicUrl(item),
    }));
  }
  private buildDynamicUrl(element: any): string {
    return `${urlRoutes.dashboard}/all-application/info/${element.id}`;
  }

  // Employee Directory
  openEmployeeDirectory() {
    this.dialog.open(EmployeeDirectoryComponent, {
      panelClass: 'custom-dialog-container',
      width: '1500px',
      // height: '90vh',
      disableClose: true,
      position: { top: '80px' },
    });
  }

  async markAsAway(): Promise<void> {
    const currentUser = await this.localStorageService.getKeyIndexedDbKey('currentUser');
    const breakStartTime = Date.now();

    this.loader.show();
    this.tmsService.breakStart(currentUser?.id).subscribe({
      next: () => {
        this.loader.hide();
        this.tmsSocketService.markLocked(breakStartTime);
        this.tmsSocketService.saveAwayOption(TMS_MANUAL_AWAY_OPTION);
        this.tmsSocketService.showLockOverlay();
      },
      error: (err: any) => {
        this.loader.hide();
        const msg = err?.error?.message || 'Failed to set away status. Please try again.';
        this.popup.successAndErrorDialog('error', msg);
      },
    });
  }

  openHolidayMaster() {
    this.router.navigate([`${urlRoutes.dashboard}/holiday-master`]);
  }

  internalChat() {
    this.router.navigate([`${urlRoutes.dashboard}/internal-chat`]);
  }

  redirectToAutomationPortal() {
    const token = this.localStorageService.getKey('access_token');
    if (token) {
      const automationUrl = `${environment.automationPortalUrl}?token=${token}`;
      window.open(automationUrl, '_blank');
    } else {
      console.error('No access token found');
      // Optionally show a user-friendly message
      this.popup.successAndErrorDialog('error', 'Authentication token not found. Please login again.');
    }
  }
  goToCrizacMRC() {
    window.open('https://mrc-hub.crizac.ai/', '_blank');
  }
  onMenuOpened() {
    this.qrRef?.refresh();
  }

  tms() {
    const token = localStorage.getItem('access_token');
    let url = `${environment.tmsURL}?token=${token}`;
    if (token) {
      window.open(url, '_blank');
    }
  }

  momos() {
    const token = localStorage.getItem('access_token');
    let url = `${environment.momosUrl}?token=${token}`;
    if (token) {
      window.open(url, '_blank');
    }
  }

  async gotoHITL() {
    const user = await this.localStorageService.getKeyIndexedDbKey('currentUser')
    const userName = user?.driveData?.userName
    this.LoaderService.show();

    this.allApplicationService.fetchHitl(userName).subscribe({
      next: (res: any) => {
        const loginUrl = res.data.data.loginUrl;

        if (loginUrl) {
          window.open(loginUrl, '_blank'); // opens in new tab
          this.LoaderService.hide();
        } else {
          console.error('Login URL not found in response');
          this.LoaderService.hide();
        }

      }, error: (err: any) => {
        console.error("Something Went Wrong!!");
        this.popup.successAndErrorDialog(
          'error',
          'No credentials were found. Please contact the IT team for assistance.'
        );
        this.LoaderService.hide();
      }
    })

  }
  toggleNotification(event: any): void {
    const payload = {
      noticeHideShow: event.checked.toString()
    };
    this.allApplicationService.notificationShowHide(payload).subscribe({
      next: (res: any) => {
        if (res?.success) {
          // Update current user object
          this.currentUsers.noticeHideShow = event.checked.toString();
          // Save updated object
          this.localStorageService.setIndexedDbKey(
            'currentUser',
            this.currentUsers
          );
          this.popup.successAndErrorDialog(
            'success',
            `Notifications ${event.checked ? 'enabled' : 'disabled'} successfully.`
          );
        }
      },
      error: (err: any) => {
        console.error(err);
        this.popup.successAndErrorDialog(
          'error',
          'Failed to update notification settings.'
        );
      }
    });
  }
  newsletter() {
    // window.open(
    //   'https://www.crizac.com/crizac_chronicle/crizac_chronicle_2026.html',
    //   '_blank'
    // );
    this.router.navigate(['/dashboard/news']);
  }
}

